export const overflow_x_hide =`
.overflow-x-hide {
    overflow-x: hidden !important;
}
`;
export const overflow_y_hide =`
.overflow-y-hide {
    overflow-y: hidden !important;
}
`;
export const overflow_hide =`
.overflow-hide {
    overflow: hidden !important;
}
`;
export const overflow_x_show =`
.overflow-x-show {
    overflow-x: visible !important;
}
`;
export const overflow_y_show =`
.overflow-y-show {
    overflow-y: visible !important;
}
`;
export const overflow_show =`
.overflow-show {
    overflow: visible !important;
}
`;
export const overflow_x_scroll =`
.overflow-x-scroll {
    overflow-x: scroll !important;
}
`;
export const overflow_y_scroll =`
.overflow-y-scroll {
    overflow-y: scroll !important;
}
`;
export const overflow_scroll =`
.overflow-scroll {
    overflow: scroll !important;
}
`;
export const overflow_x_auto =`
.overflow-x-auto {
    overflow-x: auto !important;
}
`;
export const overflow_y_auto =`
.overflow-y-auto {
    overflow-y: auto !important;
}
`;
export const overflow_auto =`
.overflow-auto {
    overflow: auto !important;
}
`;